import React from 'react';
import { prIa } from '../services/api';
import AnalyseIaRapport from './AnalyseIaRapport';

// ─── Analyse IA des pièces — panneau latéral de PR — Performance ────────────
// Auto Antilles (2026-10-02), sur la période du rapport. Mécanique commune :
// AnalyseIaRapport.
export default function PrAnalyseIa({ libellePeriode, ...props }) {
  return (
    <AnalyseIaRapport {...props} api={prIa} titre="Analyse IA des pièces de rechange" prefixeFichier="analyse-pieces"
      sousTitre={`Auto Antilles · ${libellePeriode} contre la même période N-1 · concessions pseudonymisées, marques et références en clair, aucun client ni vendeur`} />
  );
}
